import React from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { Navigate } from "react-router-dom"
import { AUTH0_CONFIG } from "../../api/endpoints"

interface RoleGuardProps {
  allowedRoles: string[]
  children: React.ReactNode
}

const RoleGuard: React.FC<RoleGuardProps> = ({ allowedRoles, children }) => {
  const { isAuthenticated, user, isLoading } = useAuth0()

  if (isLoading) {
    return <div>Cargando...</div>
  }

  const roles: string[] =
    (user?.[AUTH0_CONFIG.AUDIENCE_ROL] as string[] | undefined) ?? []

  const isAuthorized =
    isAuthenticated && allowedRoles.some((role) => roles.includes(role))

  if (!isAuthorized) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default RoleGuard
